import { useSelector } from 'react-redux';
import MainContainer from "../../components/main-container/main-container.component";

import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ConnectionsWidget from '../../components/connections/connections.component';

function MyConnections() {

    const myConnection = useSelector(state => state.user.connections);

    const history = useHistory();

    return (
      <MainContainer>
        <div className="connections-container py-4">
          <div className="row">
            <div className="col-12 col-md-12">
              <div className="row">
                <div className="col-sm-6">
                  <h1 className="title mb-4">My Connections</h1>
                </div>
                <div className="col-sm-6 text-md-right">
                  <button
                    onClick={() => history.goBack()}
                    className="btn btn-md btn-outline-secondary px-4 rounded-10 btn-getmorecredit"
                  >
                    Back
                  </button>
                </div>
              </div>

              <ConnectionsWidget
                connection={Array.isArray(myConnection) ? myConnection : []}
                type="link"
                icontype="person"
                pagetype="grid"
              />
            </div>
          </div>
        </div>
      </MainContainer>
    );
}

export default MyConnections;